const genericErrorMessage = 'An error occurred. Please try again later.';

function formatCatchErrorMsg(error: unknown, customMessage?: string): string {
  console.log('🚀 formatCatchErrorMsg error: ', error);
  let message: unknown = customMessage ? customMessage : genericErrorMessage;
  if (error instanceof Error) message = error.message;
  else {
    if (typeof error === 'object' && error !== null) {
      if ('message' in error) {
        message = error.message;
      } else if ('errorMessage' in error) {
        message = error.errorMessage;
      } else if ('data' in error) {
        if (typeof error.data === 'object' && error.data !== null) {
          if ('message' in error.data) {
            message = error.data.message;
          } else if ('errorMessage' in error.data) {
            message = error.data.errorMessage;
          }
        } else if (typeof error.data === 'string') {
          message = error.data;
        }
      }
    }
  }

  if (typeof message === 'object' && message !== null) {
    if ('message' in message) {
      message = message.message;
    } else if ('errorMessage' in message) {
      message = message.errorMessage;
    }
  } else if (typeof message === 'string') {
    if (isJSON(message)) {
      const errorMessage = JSON.parse(message as string);
      if (typeof errorMessage === 'object' && errorMessage !== null) {
        if ('message' in errorMessage) {
          message = errorMessage.message;
        } else if ('errorMessage' in errorMessage) {
          message = errorMessage.errorMessage;
        }
      }
    }
  }
  if (message && JSON.stringify(message).length > 50) {
    return customMessage || genericErrorMessage;
  }
  return JSON.stringify(message);
}

export function isJSON(str: string): boolean {
  try {
    JSON.parse(str);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    return false;
  }
  return true;
}

export default formatCatchErrorMsg;
